export const getCurrentCountry = () => {
  return localStorage.getItem('tenant');
};

export const setCurrentCountry = (country) => {
  return localStorage.setItem('tenant', country);
};
